import { TypographyOptions } from '@mui/material/styles/createTypography'

const typography: TypographyOptions = {
  h1: {
    lineHeight: '43.2px', // 36 * 1.2
    fontSize: '36px',
  },
  h2: {
    lineHeight: '38.4px', // 32 * 1.2
    fontSize: '32px',
  },
  h3: {
    lineHeight: '34.8px', // 29 * 1.2
    fontSize: '29px',
  },
  h4: {
    lineHeight: '31.2px', // 26 * 1.2
    fontSize: '26px',
  },
  h5: {
    lineHeight: '27.6px', // 23 * 1.2
    fontSize: '23px',
  },
  h6: {
    lineHeight: '24px', // 20 * 1.2
    fontSize: '20px',
  },
  body1: {
    lineHeight: '25.2px', // 18 * 1.4
    fontSize: '18px',
  },
  body2: {
    lineHeight: '22.4px', // 16 * 1.4
    fontSize: '16px',
  },
  body3: {
    lineHeight: '19.6px', // 14 * 1.4
    fontSize: '14px',
  },
  caption: {
    lineHeight: '14.4px', // 12 * 1.2
    fontSize: '12px',
  },
}

export default typography
